import { SHOffer } from '../../sortingHat/types';
import { getSBOfferList } from './getSBOfferList';

export async function getSBOfferBySlug(slug: string) {
  try {
    const offers = await getSBOfferList();
    if (!offers || offers.length === 0) throw new Error('No offers found');
    const offer = offers?.find((offer: SHOffer) => offer?.generalInfo?.slug === slug);
    if (!offer) throw new Error('No offer found with this slug');
    return offer;
  } catch (error) {
    console.error(`[LIBS][SB][GET_OFFER]: `, error);
    return null;
  }
}
